import React, { useEffect, useRef, useState } from "react";
import "./BybCustomer.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import scope from "../../assets/images/scope.svg";
// import scan from "../../assets/images/scan.svg";
// import bulb from "../../assets/images/bulb.svg";
import find from "../../../assets/selfaudit/images/find.svg"
import analyze from "../../../assets/selfaudit/images/analyze.svg"
import optimize from "../../../assets/selfaudit/images/optimize.svg"
gsap.registerPlugin(ScrollTrigger);

const BybCustomer = () => {
  const videoRef = useRef(null);
  const triggerRef = useRef(null);
  const hasPlayed = useRef(false); // Track if the video has already played
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const video = videoRef.current;
    const trigger = triggerRef.current;

    if (!video || !trigger) return;

    const handleScrollTrigger = () => {
      ScrollTrigger.create({
        trigger: trigger, // Element that triggers the video play
        start: "top top", // When the text reaches the top of the screen
        onEnter: () => {
          if (!hasPlayed.current) {
            video.play(); // Play the video
            hasPlayed.current = true; // Mark as played
          }
        },
      });
    };

    if (video.readyState >= 2) {
      handleScrollTrigger();
    } else {
      video.addEventListener("loadedmetadata", handleScrollTrigger);
    }

    // Stop the video when it ends
    const handleVideoEnd = () => {
      video.pause();
      video.currentTime = 5; // Reset the video to the start
    };

    video.addEventListener("ended", handleVideoEnd);

    return () => {
      ScrollTrigger.getAll().forEach((trigger) => trigger.kill());
      video.removeEventListener("loadedmetadata", handleScrollTrigger);
      video.removeEventListener("ended", handleVideoEnd);
    };
  }, []);


  const textRef = useRef(null);

    // Intersection Observer for fade-in text
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting); // Set visibility based on intersection
        },
        {
          threshold: 0.5, // Trigger when 50% of the element is visible
        }
      );
  
      const textElement = textRef.current;
      if (textElement) observer.observe(textElement);
  
      return () => {
        if (textElement) observer.unobserve(textElement);
      };
    }, []);
    
    
  return (
    <section className="check_list byb_believe">
      <div className="container">
        {/* Text trigger element */}
        <div className="byb-checklist-header" ref={triggerRef}>
          <p ref={textRef}
              className={`fade-in-text ${isVisible ? "visible" : ""}`}>IN KIT – DIGITAL AUDIT TOOL</p>
          <h1>
            <span className="d-inline d-lg-block d-sm-block">Your First Impression is Digital</span> Make It Count.
          </h1>
        </div>

        {/* Video Section */}
        <div
          className="scroll-through-hero st-hero-animate sth-fadein-off byb-toolkit"
          // style={{
          //   height: "100vh",
          //   overflow: "hidden",
          // }}
        >
          <div className="scroll-through-hero-pin scroll_pin desktop_show">
            <div className="video-container">
              <video
                ref={videoRef}
                src="https://brewyourbrand.blr1.digitaloceanspaces.com/book2.webm"
                playsInline
                webkit-playsInline
                preload="metadata"
                muted
                className="video-background"
                // style={{ width: "100%", height: "100%" }}
              />
            </div>
          </div>
        </div>

        {/* Mobile Image */}
        <img
          src="https://brewyourbrand.blr1.cdn.digitaloceanspaces.com/book2.svg"
          className="show_mob w-100 "
          alt="They believe in a brand"
          width="720"
          height="720"
          loading="lazy"
          decoding="async"
        />

        {/* Supporting Content */}
        {/* <div className="byb-content">
          <p className="byb-checklist-belowimg-para">
            Audit everything from identity to market position, ensuring each aspect aligns with your vision and goals.
          </p>
          <div className="byb-checklist-para">
            <div className="para scope-para">
              <img src={scope} alt="Scope Icon" />
              <p><span style={{color:"#fff"}}> Identify</span> opportunities to align more closely with your vision.</p>
            </div>
            <div className="para scan-para">
              <img src={scan} alt="Scan Icon" />
              <p>
              <span style={{color:"#fff"}}>Understand</span> where you <span className="d-block">stand in the market.</span>
              </p>
            </div>
            <div className="para bulb-para">
              <img src={bulb} alt="Bulb Icon" />
              <p><span style={{color:"#fff"}}>Gain</span> deep insights into your brand’s current state.</p>
            </div>
          </div>
        </div> */}

<div className="byb-customer-bottom">
                <div className="byb-customer-bottom-left">
                <p>From  <span style={{ color: '#FFFFFF' }}>website hygiene to social media</span>   performance, audit your digital footprint whether it is polished, competitive, and on-brand.</p>
                </div>
                  <div className="byb-customer-bottom-right">
                    <div className="byb-customer-bottom-right-top">
                          <div className="byb-customer-bottom-right-para one">
                            <img src={find} alt="Find digital brand presence icon" />
                          <p> <span style={{ color: '#FFFFFF' }}>Find</span> out if your online presence truly reflects your brand’s essence.</p>
                          </div>

                          <div className="byb-customer-bottom-right-para two">
                            <img src={optimize} alt="Optimise digital channels icon" />
                            <p><span style={{ color: '#FFFFFF' }}>Optimise </span> digital channels to engage authentically with your audience.</p>
                          </div>
                    </div>
                  <div className="byb-customer-bottom-right-below">
                      <div className="byb-customer-bottom-right-para three">
                          <img src={analyze} alt="Analyse online reputation icon" />
                          <p><span style={{ color: '#FFFFFF' }}>Analyse </span> online review practices to understand customer credibility and perception.</p>
                      </div>
                  </div>
                  </div>

              </div>
      </div>
    </section>
  );
};

export default BybCustomer;
